import { MaxImageSizes } from '@ravago/shared/page-data/enums/max-image-sizes';

import { ImageLoaderProps } from 'next/image';

function normalizeContentfulImageUrl(src: string): string {
   if (src.startsWith('//')) {
      return `https:${src}`;
   }

   if (src.startsWith('https://downloads.ctfassets.net/')) {
      return src.replace('https://downloads.ctfassets.net/', 'https://images.ctfassets.net/');
   }

   if (src.startsWith('https://images.ctfassets.net')) {
      return src;
   }

   return `https://images.ctfassets.net${src}`;
}

function calculateProportionalHeight(url: URL, targetWidth: number): number | undefined {
   const originalWidth = url.searchParams.get('w');
   const originalHeight = url.searchParams.get('h');

   if (!originalWidth || !originalHeight) {
      return undefined;
   }

   const aspectRatio = Number.parseInt(originalWidth, 10) / Number.parseInt(originalHeight, 10);

   if (aspectRatio > 0) {
      return Math.round(targetWidth / aspectRatio);
   }

   return undefined;
}

export function contentfulLoader({ src, width, quality }: ImageLoaderProps) {
   const imageUrl = normalizeContentfulImageUrl(src);
   const targetWidth = Math.min(width, MaxImageSizes.IMAGE);

   const originalUrl = new URL(imageUrl);
   const calculatedHeight = calculateProportionalHeight(originalUrl, targetWidth);

   const url = new URL(imageUrl);
   url.searchParams.delete('h');
   url.searchParams.set('fm', 'webp');
   url.searchParams.set('w', targetWidth.toString());
   url.searchParams.set('q', (quality || 75).toString());

   if (calculatedHeight) {
      url.searchParams.set('h', calculatedHeight.toString());
   }

   return url.href;
}